<div class="page-well" 
[ngClass]="{
  'page-well--no-border': !showBorder,
  'no-padding-mobile': noPaddingMobile
}">
  <ng-content></ng-content>
</div>
